import { createSelector } from '@ngrx/store';
import { getRoles } from 'src/app/shared/selectors/roles.selectors';
import { getDragonflyState } from '../reducers';

export const getBrandState = createSelector(getDragonflyState, (state) => state.brandManagement);

export const getPanelExpanded = createSelector(getBrandState, ({ panelExpanded }) => panelExpanded);

export const getCouponSetValues = createSelector(
  getBrandState,
  ({ couponSetValues }) => couponSetValues,
);

export const getSelectedCouponSetCode = createSelector(
  getBrandState,
  ({ selectedCouponSetCode }) => selectedCouponSetCode,
);

export const getBrandCode = createSelector(getBrandState, ({ brandCode }) => brandCode);

export const getSearchDisabled = createSelector(getRoles, (roles) =>
  Object.keys(roles).includes('tags.search') ? false : true,
);
